export default "__VITE_ASSET__ba2809f7__"